import NotificationsPage from 'pages/notifications/NotificationsPage';
import DefaultLayout from 'components/layout/DefaultLayout';
import routes from 'common/routes';
import { roles } from 'common/constants/options';

// Centro de notificaciones: la ruta /notifications existía en common/routes pero nunca se
// registró en el router (el "ver todas" del menú estaba comentado apuntando a la nada).
const notificationCenterRoutes = [
  {
    key: 'notifications-center',
    exact: true,
    path: routes.notifications.path,
    component: NotificationsPage,
    layout: DefaultLayout,
    allowedRoles: [roles.administrator, roles.supervisor, roles.trainer, roles.client]
  }
];

export default notificationCenterRoutes;
